import * as React from "react";
import { useDispatch } from "react-redux";
import styled, { css } from "styled-components";

import { ActivityActions } from "@com.mgmtp.a12.client/client-core/lib/core/activity";
import { Button } from "@com.mgmtp.a12.widgets/widgets-core/lib/button";
import { addPrefix } from "@com.mgmtp.a12.widgets/widgets-core/lib/common";
import { ActionContentbox, ContentBoxElements } from "@com.mgmtp.a12.widgets/widgets-core/lib/contentbox";
import { Icon } from "@com.mgmtp.a12.widgets/widgets-core/lib/icon";
import {
	ButtonGroupContainer,
	ButtonGroupContainerProps
} from "@com.mgmtp.a12.widgets/widgets-core/lib/layout/button-group-container";

interface SimpleContentBoxProps extends React.PropsWithChildren {
	readonly activityId: string;
	readonly title?: string;
	readonly ariaLevel?: number;
	readonly closeButtonTitle?: string;
	readonly footerButtons?: ButtonGroupContainerProps.ButtonProps[];
	readonly embedded?: boolean;
}

export const SimpleContentBox: React.ComponentType<SimpleContentBoxProps> = function SimpleContentBox(props) {
	const dispatch = useDispatch();

	const onCloseClick = React.useCallback(
		() => dispatch(ActivityActions.cancelRequested({ activityIds: [props.activityId] })),
		[dispatch, props.activityId]
	);

	return (
		<ActionContentbox
			headingElements={<StyledContentBoxTitle text={props.title} ariaLevel={props.ariaLevel} />}
			headingButtons={
				<ContentBoxElements.HeadingAddon>
					<Button title={props.closeButtonTitle} icon={<Icon>close</Icon>} onClick={onCloseClick} />
				</ContentBoxElements.HeadingAddon>
			}
			padding={!props.embedded}
			footer={
				props.footerButtons && (
					<ContentBoxElements.Footer>
						<ButtonGroupContainer rightSlotButtons={props.footerButtons} />
					</ContentBoxElements.Footer>
				)
			}
			className={addPrefix("-u-rounded")}
		>
			{props.children}
		</ActionContentbox>
	);
};

const StyledContentBoxTitle = styled(ContentBoxElements.Title)`
	${({ ariaLevel, theme }) =>
		ariaLevel === 1
			? css`
					font-size: ${theme.typography.fontSize.hugeFontSize};
				`
			: ""}
`;
